import uuid from './uuid';

export function generateCorrelationId() {
	return uuid();
}

export const correlationIdHeaderName = 'X-Correlation-Id';
